/**
 * Created by Administrator on 2018/1/2.
 */

exports.install = function (Vue, options) {
  // 判断小程序
  Vue.prototype.miniprogram = function () {
    function ready() {
      if(window.__wxjs_environment === 'miniprogram'){
        return true;
      }else{
        return false;
      }
    }
    if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
      document.addEventListener('WeixinJSBridgeReady', ready, false)
    } else {
      return ready()
    }
  };
  // 判断安卓
  Vue.prototype.isAndroid = function () {
    var u = navigator.userAgent, app = navigator.appVersion;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    if (isAndroid) {
      setTimeout(function () {
        $('#login_Alert').removeClass('fade')
      }, 1000)
    }
  };
  // 判断跳转页面
  Vue.prototype.hrefHTML = function (type, actId) {
    /*    var addArr = [86453, 81424, 81680, 86746, 52985, 80727, 84237, 81741, 81752, 81758, 79059, 78685, 77066, 77761, 78618, 84357, 80513, 80469, 80465, 79394, 77703, 63536, 62611, 58826, 57722, 54618, 54394, 54385, 54373, 54222, 54223, 54224, 46362, 52875, 50399, 48644, 47992, 47693];
        //addArr.indexOf(actId)
        for (var i = 0; i < addArr.length; i++) {
          if (addArr[i] == actId) {
            //判断类型
            if (actId == '80727' || actId == '86453') {
              return 'http://ishow.xiyou.cctv.com/seriesactive.html?iid=' + actId
            } else {
              return 'http://ishow.xiyou.cctv.com/active.html?iid=' + actId;
            }

          }
        }*/
    return false;
  }
  //分享
  Vue.prototype.removeTAG = function (str, len) {
    var str = str.replace(/<[^>]+>/g, "");
    if (typeof str != 'string' || str == null || str == '') return '';
    return str.length > len ? str.slice(0, len) + '...' : str;
  }
  Vue.prototype.weixinShare = function (data) {
    $('#script').html('');
    var script = document.createElement('script');
    var head = document.getElementById('script');
    script.src = '/h5/static/lib/weixin/jweixin.js';
    // script.src = '../../../../static/lib/weixin/jweixin.js';//开发用
    var script2 = document.createElement('script');
    script2.src = '/h5/static/lib/jsddk1.js';
    // script2.src = '../../../../static/lib/jsddk1.js';//开发用
    head.appendChild(script);
    head.appendChild(script2);

    setTimeout(function () {
      var sdkInstance = new jssdk(169, 'https://wx.cctv.com');
      /*  var success_func = function () {
          console.log('分享成功后的回调');
        };*/
      sdkInstance.share(
        data.title,
        data.desc,
        data.imgAddress,
        data.title,
        '',
        data.url
      );
    }, 800)
  }
  Vue.prototype.$setgoindex = function () {
    if (window.history.length <= 1) {
      if (location.href.indexOf('?') === -1) {
        window.location.href = location.href + '?goindex=true'
      } else if (location.href.indexOf('?') !== -1 && location.href.indexOf('goindex') === -1) {
        window.location.href = location.href + '&goindex=true'
      }
    }
  }
  Vue.prototype.isWeiXin = function () {//判断是否微信
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  }
  Vue.prototype.IsPC = function () {   //判断是否是移动 pc;
    var userAgentInfo = navigator.userAgent;
    var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod', 'UCBrowser'];
    var flag = true;

    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    if (window.screen.width >= 768) {
      flag = true;
    }
    return false;
  }
  Vue.prototype.PictureRatio = function () {  //图片尺寸比例
    //图片尺寸控制 16:9
    var banWimg = $('.dl-banner').width();
    var banHimg = Math.ceil($('.dl-banner').width() / 2 * 1);
    $('.dl-banner img').css({width: banWimg, height: banHimg, visibility: 'visible'});

    var picWimg = $('.pic-box').width();
    var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
    $('.pic-box img').css({width: picWimg, height: picHimg, visibility: 'visible'});



    //图片尺寸控制 4:3
    var picmWimg = $('.pic-box-more').width();
    var picmHimg = Math.ceil($('.pic-box-more').width() / 4 * 3);
    $('.pic-box-more img').css({width: picmWimg, height: picmHimg, visibility: 'visible'});
  };
  //验证登录
  Vue.prototype.loginFn = function () {
    /*
     var userId = this.getCookie('userSeqId')
    // var cbox = this.getCookie('cboxFrom')
    if (passport.isLoginedStatus()) {
    //if (passport.isLoginedStatus() || userId) {//本地开发用
      return true
    } else {
      //判断请求头 && cbox != 'cbox'
      if (window.isThisClient('cbox')) {
        window.location.href = 'login://qr.cntv.cn';
        return true;
      } else {
        return false
      }
    }*/
    var userId = this.getCookie('userSeqId');
    console.log(userId);
    if (window.isThisClient('cbox')) {
        data =Vue.prototype.cboxLogin();
        console.log('cbox--data -------')
        console.log(data);
        console.log('cbox--data ------- two')
        if(data ==''){
          console.log("loginFn false");
          return false;
        }
        else {
          console.log("loginFn true");
          return true;
        }
        
    }
    else{
      if (passport.isLoginedStatus() || userId) {//本地开发用
        return true;
      }
      else{
        return false;
      }
    }
  }
  Vue.prototype.cboxregisterhandler = function () {
    console.log("cbox init");
    // console.log(Vue.prototype.$bridge);
    console.log(this.$bridge);
    console.log('cctvWebMethod');
    // this.$bridge.registerHandler('cctvWebMethod',Vue.prototype.cboxregisterhandlercallback );
    this.$bridge.registerHandler('cctvWebMethod', (data, responseCallback)=>
     {    
      console.log("cbox init cctvWebMethod start");
       console.log(data);
       console.log("cbox init  cctvWebMethod end");
       
    }
    );
  }


  // Vue.prototype.cboxregisterhandlercallback = function (data,responseCallback) {
  //     console.log("cboxregisterhandlercallback start");
  //      console.log(data);
  //      console.log("cboxregisterhandlercallback end");
  // }
  Vue.prototype.cboxLogin = function () {
    let params ={ type:1001,param: {needLogin:1}};
    console.log('cctvNativeMethod');
    this.$bridge.callHandler('cctvNativeMethod', params, function(responseData){
      console.log('cboxlogin cctvNativeMethod cboxlogin start');
      console.log(responseData);
      // var user = JSON.parse(responseData);
      var jsonresponseData = JSON.parse(responseData);
      // 处理返回数据
      Vue.prototype.setCctvCookie('verifycode',jsonresponseData.verifyCode);
      Vue.prototype.setCctvCookie('userSeqId',jsonresponseData.userId);
      Vue.prototype.setCookie('verifycode',jsonresponseData.verifyCode);
      Vue.prototype.setCookie('userSeqId',jsonresponseData.userId);
      console.log('cboxlogin cctvNativeMethod cboxlogin end');
      return jsonresponseData.userId;
    }
  )
  }

  Vue.prototype.cboxShare = function (shareImageUrl,shareUrl,shareTitle,shareContent) {
    let params ={ type:1005,param: {shareImageUrl:shareImageUrl,shareUrl:shareUrl,shareTitle:shareTitle,shareContent:shareContent}};
    this.$bridge.callhandler('cctvNativeMethod', params);
  }
 
  Vue.prototype.BuriedCode = function () {
    //var html =  $('<script>\
    //   var _hmt_citic = _hmt_citic || [];\
    //   _hmt_citic.u="http://data.qr.cntv.cn";\
    //   _hmt_citic.p="2018ishow";\
    //   (function () {\
    //     var hm = document.createElement("script");\
    //     hm.src = "http://static.qr.cntv.cn//qr/js/monitor.js?v=2017";\
    //     var s = document.getElementsByTagName("script")[0];\
    //     s.parentNode.insertBefore(hm, s);\
    //   })();\
    // </script>');
    // return html;
  }

  Vue.prototype.getCookie = function (name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
      return unescape(arr[2]);
    else
      return null;
  }
  Vue.prototype.setCookie = function (name, value) {
    var Days = 30;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
  }
  Vue.prototype.setCctvCookie = function (name, value) {
    var Days = 1;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + '; path=/' + ";expires=" + exp.toGMTString()+ ";domain=.cctv.com";
  }
  //视频播放
  /*
  Vue.prototype.VideoPlay = function (uuid, W, H, ID) {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      // 移动
      var _player_width = W || document.documentElement.clientWidth;  //播放窗口宽度
      var _player_height = H || Math.ceil(document.documentElement.clientWidth / 1.78);   //播放窗口高度 1.78
    } else {
      // pc
      var _player_width = 640;  // 播放窗口宽度
      var _player_height = 480;  // 播放窗口高度
    }
    var hostUrl = document.location.href;
    var domainName = 'http://';
    if (hostUrl.split(':')[0] == 'https') {
      domainName = 'https://'
    } else {
      domainName = 'http://'
    }
    
    setTimeout(function () {
      var flashvars = {};
      flashvars["id"] = uuid;
      flashvars["item_id"] = uuid;
      flashvars["type"] = 'video';
      flashvars["version"] = "3.054";
      flashvars["controls"] = true;
      flashvars["static_url"] = domainName + "ishow.cctv.com/";
      flashvars["width"] = _player_width;
      flashvars["height"] = _player_height;
      flashvars["lang"] = 'zh-CN';
      flashvars["autoplay"] = false;
      flashvars["playrelationlist"] = "false";
      flashvars["configxml"] = 'player.xml';
      if (ID) {
        _XYVideoPlayer = $('#' + ID).xyPlayer(flashvars);
      } else {
        _XYVideoPlayer = $('#myFlash').xyPlayer(flashvars);
      }

      var flashURL = domainName + "ishow.cctv.com/flash/";
    }, 0)

  }
*/
  Vue.prototype.VideoPlay = function (uuid, W,H,ID) {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      //移动
      var _player_width = W || document.documentElement.clientWidth;  //播放窗口宽度
      var _player_height = H || Math.ceil(document.documentElement.clientWidth / 1.78);  //播放窗口高度 1.78
    } else {
      //pc
      var _player_width = 640;  //播放窗口宽度
      var _player_height = 480;  //播放窗口高度
    }
    //console.log(uuid,_player_width,_player_height,W)
    var fo = createCommonPlayer('vplayer', _player_width, _player_height, 'news');
    fo.addVariable('id', '');
    fo.addVariable('videoId', '');  //视频集id
    fo.addVariable('articleId', '');
    fo.addVariable('filePath', '');
    fo.addVariable('sysSource', 'xiyou');//视频来源
    fo.addVariable('channelId', '');
    fo.addVariable('url', '');//视频页面url，如http://tv.cntv.cn/video/C18472/a28126e5e0424a44af6a9bc4c5a47742
    fo.addVariable('scheduleId', 'ishow.cctv.com');//关键字
    fo.addVariable('videoCenterId', uuid); //视频生产中心guid (必要值) d5df5fd8-cf90-11e2-b091-a4badb4696b6
    fo.addVariable('isLogin', '');//用户中心相关
    fo.addVariable('userId', '');//用户中心相关
    fo.addVariable('wideMode', 'normal');
    fo.addVariable('adCall', '');	//前贴片广告    //ad_Call
    fo.addVariable('adAfter', '');	//后贴广告  //ad_After
    fo.addVariable('adPause', '');	//暂停广告  //ad_Pause
    fo.addVariable('adCorner', '');	//角标广告  //ad_Corner
    fo.addVariable('vadCurtain', '');//跑马灯广告  //ad_Curtain
    fo.addParam('wmode', 'opaque');
    fo.addVariable('repeat', 'true');
    if(ID){
      writePlayer(fo,ID);  //渲染页面的位置
    }else{
      fo.addVariable('isAutoPlay', 'true');//是否自动播放
      writePlayer(fo, 'myFlash');  //渲染页面的位置
    }
  }

};



// WEBPACK FOOTER //
// ./src/router/globalFun.js